// extracted by mini-css-extract-plugin
export var productImage = "_y0-0";